import { RouteRecordRaw } from 'vue-router'
import CompaniesChildRoutes from '@/router/companies'
import UsersChildRoutes from '@/router/users'
import store from '@/store'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'companies',
    name: 'manage.companies',
    meta: { applicationAdminOnly: true },
    redirect: { name: 'manage.companies.list' },
    children: CompaniesChildRoutes,
  },
  {
    path: 'users',
    name: 'manage.users',
    meta: { companyAdminAccess: true },
    beforeEnter: () => store.getters['user/isApplicationAdmin']
      ? { name: 'manage.companies.list' }
      : true,
    redirect: { name: 'manage.users.list' },
    children: UsersChildRoutes,
  },
  {
    path: 'access-management',
    name: 'manage.access-management',
    meta: { companyAdminAccess: true },
    component: () => import('@/views/control-panel/manage/AccessManagement.vue'),
  },
  {
    path: 'overview',
    name: 'manage.overview',
    component: () => import('@/views/control-panel/manage/Overview.vue'),
  },
  {
    path: 'sensors',
    name: 'manage.sensors',
    redirect: { name: 'manage.sensors.list' },
    children: [
      { path: '', name: 'manage.sensors.list', component: () => import('@/views/control-panel/manage/Sensors.vue') },
      { path: ':id', name: 'manage.sensors.detail', component: () => import('@/views/control-panel/manage/sensors/Detail.vue') },
    ],
  },
  {
    path: 'external-connections',
    name: 'manage.connections',
    redirect: { name: 'manage.connections.list' },
    children: [
      { path: '', name: 'manage.connections.list', component: () => import('@/views/control-panel/manage/external-connections/List.vue') },
      { path: ':id', name: 'manage.connections.detail', component: () => import('@/views/control-panel/manage/external-connections/Detail.vue') },
    ],
  },
  {
    path: 'process',
    name: 'manage.process',
    component: () => import('@/views/control-panel/manage/Process.vue'),
  },
]

export default routes
